var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[(_vm.visible)?_c('layout-navigation'):_vm._e(),_c('router-view',{attrs:{"appUsers":_vm.allUsers},on:{"hide":_vm.hideSidebar,"show":_vm.showSidebar}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }